import { Col, Container, Row } from "react-bootstrap";
import "./certificate.css";
import fancydiamond from "../../assets/img/Icons-Certificate/Fancy-Diamond.jpg";
import fulldiamond from "../../assets/img/Icons-Certificate/Full-Diamond.jpg";
import identification from "../../assets/img/Icons-Certificate/Jewelry-Identification.jpg";
import report from "../../assets/img/Icons-Certificate/Lab-Grown-Reports.jpg";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import CertificateBanner from "../../Certificate/CertificateBanner";

export default function Certificate() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        // Delay to ensure rendering
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);
  return (
    <>
      <section className="mb-4 section-spacing-x pt-5" id="certificate">
        <Container fluid>
          <Row>
            {/* <Col lg={6} className="d-flex mb-3 mb-lg-0 pe-lg-0">
              <div className="servicecard-one cursor-pointer w-100 d-flex flex-column align-items-center p-3">
                <div className="service-img mb-2 sub-heading">
                  <img src={serive1} alt="serives" className="w-100 img-fluid" />
                </div>
                <h4 className="sub-heading mb-3">Sealing Services</h4>
                <p className="para-content mb-0">
                  To provide our customers with complete rest of mind, SHDL offers you the possibility of having your diamond sealed. This sealing is a foolproof way of ensuring that a diamond and its certificate go together and prevent any possibility whatsoever of a mix-up. Sealing also keeps the diamond safe from grease and dirt and in pristine condition for when you offer it for sale to a potential client.                </p>
                <div className="read-more">
                  <Link to="/services">Read More</Link>
                </div>
              </div>
            </Col>
            <Col lg={6} className="d-flex ps-lg-0">
              <div className="servicecard-two cursor-pointer w-100  d-flex flex-column align-items-center p-3">
                <div className="service-img mb-2 sub-heading">
                  <img src={serive2} alt="serive1" className="w-100 img-fluid" />
                </div>
                <h4 className="sub-heading mb-3">Online Services</h4>
                <p className="para-content mb-0">
                  The results of all SHDL certificates are kept on file by SHDL, and for your convenience we enable you to retrieve them online.                </p>
              </div>
            </Col> */}
            <div className="col-12 text-center">
              <h2 className="heading mb-3">Diamond Reports</h2>
              <p className="certificate-section-para">
                We provide diamond certification that assures authenticity,
                quality, and value. Each diamond is rigorously tested using
                advanced gemological tools and graded by expert gemologists. Our
                certificates include a detailed analysis of the 4Cs—Cut,
                Clarity, Color, and Carat, along with additional features like
                symmetry, fluorescence, and polish.
              </p>
            </div>
            <div className="col-lg-6  mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={fulldiamond}
                    alt="Full Diamond Grading Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/full-diamond-grading-reports">
                  <h3 className="mb-0">Full Diamond Grading Reports</h3>
                </Link>
                <p className="mb-3">
                  Our diamond grading reports deliver precise analysis of cut,
                  color, clarity, and carat, providing trustworthy certification
                  that reflects the true quality and value of your diamonds.{" "}
                </p>
                <div className="service-read-more ">
                  <Link to="/full-diamond-grading-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-6  mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={identification}
                    alt="Jewelry Identification Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/diamond-jewelry-reports">
                  <h3 className="mb-0">Diamond Jewelry Reports</h3>
                </Link>
                <p className="mb-3">
                  We offer detailed jewelry identification reports that
                  accurately describe the materials, diamonds, gemstones, and
                  craftsmanship, helping you authenticate and appraise your
                  valuable jewelry pieces.{" "}
                </p>
                <div className="service-read-more ">
                  <Link to="/diamond-jewelry-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6  mb-lg-0 mb-3">
              <div className="service-card text-center border rounded">
                <div className="service-image mx-auto">
                  <img
                    src={fancydiamond}
                    alt="Fancy Diamond Report | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/fancy-diamond-reports">
                  <h3 className="mb-0">Fancy Diamond Reports</h3>
                </Link>
                <p className="mb-3">
                  Our Diamond reports specialize in grading unique colored
                  diamonds, detailing hue, tone, saturation, and quality to
                  certify the beauty and rarity of your fancy gemstones.{" "}
                </p>
                <div className="service-read-more ">
                  <Link to="/fancy-diamond-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6   mb-lg-0 mb-3">
              <div className="service-card text-center border rounded p-2">
                <div className="service-image mx-auto">
                  <img
                    src={report}
                    alt="Lab Grown Report |Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/lab-grown-reports">
                  <h3 className="mb-0">Lab Grown Reports</h3>
                </Link>
                <p className="mb-0">
                  Get reliable lab-grown diamond reports that verify
                  authenticity, quality, and characteristics, ensuring
                  transparency and confidence when buying or selling synthetic
                  diamonds.{" "}
                </p>
                <div className="service-read-more ">
                  <Link to="/lab-grown-reports">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
}
